import React, {useEffect, useState} from 'react'

import {Typography, TextField, Button, Box} from "@material-ui/core"

import {useStyles} from '../../themes/styles'

const GiftConfirm = (props) => {
  const classes = useStyles()

  useEffect(() => {
    window.scrollTo(0,0)
  },[])

  return <Typography variant="h5" className={classes.shadowBox}>
    Thanks for sharing the love. Please check your email for a confirmation from us.
  </Typography>

}

export default GiftConfirm